export default function ServicesIcon() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.34764 0.0834961C3.61928 0.0834961 3.00486 0.498536 2.58982 1.12516L0.278625 4.86865C0.172832 5.07617 0.083313 5.49935 0.083313 5.81266V18.8335C0.083313 19.981 1.01919 20.9168 2.16665 20.9168H18.8333C19.9808 20.9168 20.9166 19.981 20.9166 18.8335V5.81266C20.9166 5.49935 20.8271 5.08431 20.7213 4.771L18.4101 1.12516C17.9951 0.498536 17.3807 0.0834961 16.6523 0.0834961H4.34764ZM4.34764 2.16683H16.6523L17.8893 4.25016H3.11066L4.34764 2.16683ZM2.16665 6.3335H18.8333V18.8335H2.16665V6.3335ZM8.22133 8.41683C7.6476 8.46973 7.22443 8.98242 7.27732 9.55615C7.33022 10.1299 7.84292 10.5531 8.41665 10.5002H12.5833C12.9577 10.5042 13.3076 10.3089 13.4988 9.9834C13.686 9.65788 13.686 9.25911 13.4988 8.93359C13.3076 8.60807 12.9577 8.41276 12.5833 8.41683H8.41665C8.38409 8.41683 8.35154 8.41683 8.31899 8.41683C8.28644 8.41683 8.25389 8.41683 8.22133 8.41683Z"
        fill="currentColor"
      />
    </svg>
  );
}
